// src/components/Toggle.js
import React from 'react';

const Toggle = ({
  enabled,
  onChange,
  disabled = false,
  size = 'default' // 'small', 'default', 'large'
}) => {
  const sizeConfig = {
    small: {
      width: 36,
      height: 20,
      circleSize: 16
    },
    default: {
      width: 44,
      height: 24,
      circleSize: 20
    },
    large: {
      width: 56,
      height: 28,
      circleSize: 24
    }
  };

  const config = sizeConfig[size];
  const translateDistance = config.width - config.circleSize - 4;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      disabled={disabled}
      onClick={() => !disabled && onChange(!enabled)}
      style={{
        position: 'relative',
        display: 'inline-block',
        width: `${config.width}px`,
        height: `${config.height}px`,
        minWidth: `${config.width}px`,
        minHeight: `${config.height}px`,
        maxWidth: `${config.width}px`,
        maxHeight: `${config.height}px`,
        padding: '2px',
        borderRadius: `${config.height / 2}px`,
        backgroundColor: enabled ? '#9333ea' : '#d1d5db',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background-color 200ms ease-in-out',
        outline: 'none',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #9333ea';
      }}
      onBlur={(e) => {
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <span
        style={{
          display: 'block',
          width: `${config.circleSize}px`,
          height: `${config.circleSize}px`,
          borderRadius: '50%',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
          transform: enabled ? `translateX(${translateDistance}px)` : 'translateX(0px)',
          transition: 'transform 200ms ease-in-out',
          flexShrink: 0,
        }}
      />
    </button>
  );
};

export default Toggle;
